module.exports = __webpack_public_path__ + "assets/img/open.d867e763.png";